import 'lodash';
import appConfig from '../config';
import { appEvents } from '../services';
import axios from 'axios';
import '../store';
import { v4 } from 'uuid';
export var StatisticsType;
(function (StatisticsType) {
    StatisticsType["COMPILE_LOW_QUALITY_RENDER"] = "COMPILE_LOW_QUALITY_RENDER";
    StatisticsType["COMPILE_FULL_RENDER"] = "COMPILE_FULL_RENDER";
    StatisticsType["VIDEO_DOWNLOAD_QUEUE_TIME"] = "VIDEO_DOWNLOAD_QUEUE_TIME";
    StatisticsType["VIDEO_DOWNLOAD_RENDER_TIME"] = "VIDEO_DOWNLOAD_RENDER_TIME";
})(StatisticsType || (StatisticsType = {}));
export class Statistic {
    id;
    type;
    createdAt;
    updatedAt;
    value;
    metadata;
    constructor(type) {
        if (appEvents && appEvents.userId) {
            this.id = appEvents.userId + '-' + v4();
        }
        else {
            this.id = v4(); // Try to just create a unique id for this statistic anyways.
        }
        this.type = type;
        this.metadata = {};
    }
    setMetadata(metadata) {
        this.metadata = metadata;
    }
    toJSON() {
        return {
            process_id: this.id,
            event: this.type,
            metadata: this.metadata
        };
    }
}
export class StatisticsService {
    static STATISTICS_URL = appConfig.statisticsUrl;
    client;
    constructor() {
        if (!window.brushApiToken)
            console.warn('[StatisticsService] No Brush API Token found, statistics will be sent without authentication');
        this.client = axios.create({
            baseURL: StatisticsService.STATISTICS_URL,
            headers: {
                Authorization: 'Bearer ' + window.brushApiToken,
                'Content-Type': 'application/json'
            }
        });
    }
    async create(type) {
        const statistic = new Statistic(type);
        return statistic;
    }
    async save(statistic, data) {
        try {
            statistic.metadata = { ...statistic.metadata, ...data };
            await this.client.post('/customer/event-logs', statistic.toJSON());
        }
        catch (err) {
            console.error('Error saving statistic', err);
        }
    }
}
const statisticsService = new StatisticsService();
export default statisticsService;
